<template>
    <header
        class="fixed top-0 inset-x-0 z-30 flex items-center w-full border-teal-500 bg-white shadow text-sm"
        style="border-top-width: 8px;"
    >
        <div class="container relative lg:static uppercase lg:flex lg:justify-between lg:px-4">
            <div class="px-4 lg:px-0 flex justify-between items-center font-headings py-6">
                <div class="flex items-center">
                    <div class="logo mr-8">
                        <a :href="homePageUrl">
                            <img class="w-40" src="/images/yagankar_logo.png" alt="YaganKar Logo" />
                        </a>
                    </div>
                </div>
                <div class="flex items-center">
                    <div class="relative lg:hidden mr-3">
                        <button class=" flex items-center focus:outline-none" @click="openNotifications">
                            <svg-icon icon="notification" class="icon-gray w-6"></svg-icon>
                        </button>
                        <span
                            v-show="notifications.length > 0"
                            class="absolute"
                            style="height:10px; width:10px; border-radius: 50%; background: red; top: 0px; left: 14px"
                        ></span>
                    </div>
                    <button
                        class="block lg:hidden text-gray-600 focus:outline-none flex items-center"
                        @click="isMenuOpen = !isMenuOpen"
                    >
                        <svg-icon v-show="!isMenuOpen" icon="menu" class="icon-gray w-6"></svg-icon>
                        <svg-icon v-show="isMenuOpen" icon="close-circle" class="icon-gray w-6"></svg-icon>
                    </button>
                </div>
            </div>

            <notification-list
                v-if="showNotifications"
                :notifications="notifications"
                class="block lg:hidden absolute z-30 w-full"
                @notification-read="readNotification"
            />
            <div
                :class="{ block: isMenuOpen, hidden: !isMenuOpen }"
                class="absolute lg:static bg-white w-full shadow-lg lg:shadow-none px-4 lg:px-0 z-50 nav-items pb-3 pt-2 lg:py-0 text-gray-500 lg:flex flex-row flex-grow items-center font-headings"
            >
                <HeaderSearch />
                <div class="flex flex-col lg:flex-row pb-2 sm:pb-0">
                    <a
                        v-if="authUser() && (authUser().account_type === 'employer' || authUser().account_type === 'freelancer')"
                        href="/my-projects"
                        class="-mx-4 text-gray-500 lg:mx-0 px-2 lg  xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                        My Jobs
                    </a>
                    <a
                        v-if="authUser() && authUser().account_type === 'employer'"
                        href="/projects/new"
                        class="block lg:hidden -mx-4 text-gray-500 lg:mx-0 px-2 lg  xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                        Add New Job
                    </a>
                    <a
                        v-if="authUser() === null || authUser().account_type === 'employer'"
                        href="/profiles"
                        class="-mx-4 text-gray-500 lg:mx-0 px-2 lg  xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                        Find Talent
                    </a>
                    <a
                        v-if="authUser() === null || authUser().account_type === 'freelancer'"
                        href="/projects"
                        class="-mx-4 text-gray-500 lg:mx-0 px-2 lg  xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                        Find Work
                    </a>
                    <a
                        href="/blog"
                        class="-mx-4 text-gray-500 lg:mx-0 px-2 lg  xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                        Blog
                    </a>
                    <a
                        href="/learn"
                        class="-mx-4 text-gray-500 lg:mx-0 px-2 lg  xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                        Learn
                    </a>
                    <div class="mr-3 xl:mr-5 relative">
                        <a
                            v-if="authUser()"
                            href="/my-conversations"
                            class="-mx-4 text-gray-500 lg:mx-0 pl-4 pr-5 py-2 font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                        >
                            Inbox
                            <span
                                v-show="unreadMessagesCount > 0"
                                class="absolute text-center"
                                style="height:15px; width:15px; border-radius: 50%; background: red; top: 0px; right: 8px; color: white; font-size: 10px;"
                                >{{ unreadMessagesCount }}</span
                            >
                        </a>
                    </div>
                </div>
                <div class="lg:flex lg:items-center justify-between flex-grow">
                    <div class="flex flex-col lg:flex-row"></div>
                    <div v-if="isLoggedIn" class="flex flex-col lg:flex-row lg:items-center">
                        <div class="mr-4 hidden lg:block">
                            <a
                                v-if="authUser() === null || authUser().account_type === 'employer'"
                                href="/projects/new"
                                class="-mx-4 lg:mx-0 btn btn-primary normal-case rounded-full"
                                title="New Job"
                            >
                                <span class="fa fa-plus-circle"></span> <span class="hidden xl:inline">New Job</span>
                            </a>
                        </div>
                        <div class="relative flex hidden lg:block">
                            <div class="flex items-center">
                                <div class="mr-5 relative relative">
                                    <button class=" flex items-center focus:outline-none" @click="openNotifications">
                                        <svg-icon icon="notification" class="icon-gray w-6"></svg-icon>
                                    </button>
                                    <span
                                        v-show="notifications.length > 0"
                                        class="absolute"
                                        style="height:10px; width:10px; border-radius: 50%; background: red; top: 0px; left: 14px"
                                    ></span>
                                    <notification-list
                                        v-if="showNotifications"
                                        :notifications="notifications"
                                        class="hidden lg:block absolute z-30 w-96 max-w-2xl right-0 mt-2"
                                        @notification-read="readNotification"
                                    />
                                </div>
                                <button
                                    class="relative z-10 block h-12 w-12 rounded-full overflow-hidden border-2 border-teal-500 focus:outline-none focus:border-gray-300"
                                    @click="isUserMenuOpen = !isUserMenuOpen"
                                >
                                    <user-avatar :avatar-url="authUser().avatar_url" :username="authUser().name"></user-avatar>
                                </button>
                            </div>
                            <button
                                v-show="isUserMenuOpen"
                                tabindex="-1"
                                class="fixed inset-0 h-full w-full bg-black opacity-50 cursor-default"
                                @click="isUserMenuOpen = false"
                            ></button>
                            <div v-show="isUserMenuOpen" class="absolute right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl">
                                <a href="/profiles/me" class="block px-4 py-2 text-gray-800 hover:bg-teal-500 hover:text-white">
                                    My Public Profile
                                </a>
                                <a
                                    :href="`/users/${authUser().id}/account`"
                                    class="block px-4 py-2 text-gray-800 hover:bg-teal-500 hover:text-white"
                                >
                                    My Account
                                </a>
                                <a
                                    href="#"
                                    class="block px-4 py-2 text-gray-800 hover:bg-teal-500 hover:text-white"
                                    @click="logout"
                                >
                                    Logout
                                </a>
                            </div>
                            <button
                                v-show="showNotifications"
                                tabindex="-1"
                                class="fixed inset-0 h-full w-full cursor-default"
                                @click="showNotifications = false"
                            ></button>
                        </div>
                        <div class="lg:hidden border-t border-gray-300 pt-4">
                            <div
                                class="z-10 block h-12 w-12 mb-3 rounded-full overflow-hidden border-2 border-teal-600 focus:outline-none focus:border-white"
                            >
                                <user-avatar :avatar-url="authUser().avatar_url" :username="authUser().name"></user-avatar>
                            </div>
                            <div class="flex flex-col">
                                <a
                                    class="-mx-4 text-gray-500 lg:mx-0 px-4 py-2 font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                                    href="/profiles/me"
                                >
                                    My Public Profile
                                </a>
                                <a
                                    class="-mx-4 text-gray-500 lg:mx-0 px-4 py-2 font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                                    :href="`/users/${authUser().id}/account`"
                                >
                                    My Account
                                </a>
                                <a
                                    class="-mx-4 text-gray-500 lg:mx-0 px-4 py-2 font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                                    href="#"
                                    onclick="event.preventDefault(); document.getElementById('logout-form').submit();"
                                >
                                    Logout
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex flex-col lg:flex-row">
                        <a
                            href="/login"
                            class="-mx-4 text-gray-500 lg:mx-0 px-2 xl:px-4 py-2 whitespace-no-wrap font-semibold block outline-none hover:bg-gray-200 hover:text-gray-800"
                        >
                            Login
                        </a>
                        <a
                            href="/register"
                            class="-mx-4 text-gray-500  lg:mx-0 px-2 xl:px-4 py-2 whitespace-no-wrap font-semibold mt-1 lg:mt-0 lg:ml-1 block outline-none hover:bg-gray-200 hover:text-gray-800"
                        >
                            Sign Up
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: {
        homePageUrl: {
            type: String,
            required: true
        },
        isLoggedIn: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isMenuOpen: false,
            isUserMenuOpen: false,
            showNotifications: false,
            notifications: [],
            unreadMessagesCount: 0
        };
    },

    mounted() {
        if (this.authUser()) {
            this.fetchNotifications(() => {
                this.initListener();
            });

            this.getUnreadMessagesCount();
        }
    },

    methods: {
        openNotifications() {
            if (!this.showNotifications) {
                this.fetchNotifications(() => {
                    this.showNotifications = true;
                });

                return;
            }

            this.showNotifications = false;
        },
        fetchNotifications(callback) {
            axios.get('/api/notifications').then(response => {
                this.notifications = response.data.data;
                callback();
            });
        },

        readNotification(id) {
            axios.patch(`/api/notifications/${id}/mark-as-read`).then(response => {
                this.notifications = response.data.data;
            });
        },

        initListener() {
            Echo.private(`App.User.${this.authUser().id}`).notification(notification => {
                this.appendNotification(notification);
            });
        },

        appendNotification(notification) {
            this.notifications.unshift({
                created_at: 'Now',
                data: notification
            });
        },

        logout() {
            axios.post('/logout').then(() => {
                location.href = '/';
            });
        },

        getUnreadMessagesCount() {
            axios.get('/api/conversations/unread-messages/count').then(response => {
                this.unreadMessagesCount = response.data.count;
            });
        }
    }
};
</script>
